module.exports = __webpack_public_path__ + "img/backgraund-user.05a74347.jpg";